import { render, staticRenderFns } from "./haveRelease.vue?vue&type=template&id=1a880e37&scoped=true&"
import script from "./haveRelease.vue?vue&type=script&lang=js&"
export * from "./haveRelease.vue?vue&type=script&lang=js&"
import style0 from "./haveRelease.vue?vue&type=style&index=0&id=1a880e37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a880e37",
  null
  
)

export default component.exports